module.exports = require("webpack-hot-middleware");


//////////////////
// WEBPACK FOOTER
// external "webpack-hot-middleware"
// module id = 52
// module chunks = 0